"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BundleContext = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireWildcard(require("react"));

var _reactRhumb = require("react-rhumb");

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _MarketingHubBundle = _interopRequireDefault(require("./MarketingHubBundle"));

var _SalesHubBundle = _interopRequireDefault(require("./SalesHubBundle"));

var _ServiceHubBundle = _interopRequireDefault(require("./ServiceHubBundle"));

var _ShoppingCart = _interopRequireDefault(require("./shopping-cart/ShoppingCart"));

var _AddOns = _interopRequireDefault(require("./AddOns"));

var _Services = _interopRequireDefault(require("./Services"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _CurrencyPicker = _interopRequireDefault(require("../common/CurrencyPicker"));

var _FooterMicrocopy = _interopRequireDefault(require("../common/FooterMicrocopy"));

var _getUsageTracker = _interopRequireDefault(require("../../utils/getUsageTracker"));

var _Tracking = require("../../constants/Tracking");

var _CurrencySelectors = require("../../selectors/CurrencySelectors");

var _CountrySelectors = require("../../selectors/CountrySelectors");

var _LoadingStateSelectors = require("pricing-pages-unified-ui/selectors/LoadingStateSelectors");

var _TabLayout = _interopRequireDefault(require("../tabs/TabLayout"));

var _AddonBundleRestrictionsMap = _interopRequireDefault(require("pricing-pages-unified-ui/constants/AddonBundleRestrictionsMap"));

var _DocumentUtils = require("pricing-pages-unified-ui/utils/DocumentUtils");

var _PageContainer = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/PageContainer"));

var _SpinnerLoadWrapper = _interopRequireDefault(require("../../components/loading/SpinnerLoadWrapper"));

var _PhoneSupport = _interopRequireDefault(require("pricing-pages-unified-ui/components/common/PhoneSupport"));

var _FailedLoadBanner = _interopRequireDefault(require("pricing-pages-unified-ui/components/loading/FailedLoadBanner"));

var _responsiveBreakpoints = _interopRequireDefault(require("../../utils/responsiveBreakpoints"));

var _CmsHubBundle = _interopRequireDefault(require("pricing-pages-unified-ui/components/bundle-page/CmsHubBundle"));

var _queryParamUtils = require("../../utils/queryParamUtils");

var _stateUtils = require("../../utils/stateUtils");

var _MarketingContactsSelectors = require("../../selectors/MarketingContactsSelectors");

function _templateObject8() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    margin-right: 0;\n  "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    flex-basis: 60%;\n  "]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    flex-direction: column;\n  "]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    width: 100%;\n  "]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    flex-basis: 40%;\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    padding: 0 15px;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    padding: 0 15px;\n    text-align: left;\n    margin-bottom: 30px;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n    padding: 0 15px;\n    text-align: left;\n    margin-top: .98em ;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var BundleContext = _react.default.createContext(null);

exports.BundleContext = BundleContext;

var PageTitle = _styledComponents.default.div.withConfig({
  displayName: "BundlePage__PageTitle",
  componentId: "sc-1kfcom5-0"
})(["text-align:center;font-size:32px;padding-top:40px;margin-bottom:10px;font-weight:600;line-height:40px;", ""], _responsiveBreakpoints.default.tabletPortrait(_templateObject()));

var SubTitle = _styledComponents.default.div.withConfig({
  displayName: "BundlePage__SubTitle",
  componentId: "sc-1kfcom5-1"
})(["text-align:center;font-size:16px;margin-bottom:56px;", ""], _responsiveBreakpoints.default.tabletPortrait(_templateObject2()));

var FailedContentContainer = _styledComponents.default.div.withConfig({
  displayName: "BundlePage__FailedContentContainer",
  componentId: "sc-1kfcom5-2"
})(["max-width:1200px;margin:0 auto;padding:45px 0 0;"]);

var ContentContainer = _styledComponents.default.div.withConfig({
  displayName: "BundlePage__ContentContainer",
  componentId: "sc-1kfcom5-3"
})(["max-width:1200px;margin:0 auto;padding:0 80px;", ";"], _responsiveBreakpoints.default.tabletPortrait(_templateObject3()));

var StickyContainer = _styledComponents.default.div.withConfig({
  displayName: "BundlePage__StickyContainer",
  componentId: "sc-1kfcom5-4"
})(["position:-webkit-sticky;position:sticky;top:9%;", ";", ";margin-bottom:60px;"], _responsiveBreakpoints.default.cs(_templateObject4()), _responsiveBreakpoints.default.tabletPortrait(_templateObject5()));

var FlexMain = (0, _styledComponents.default)(_UIFlex.default).withConfig({
  displayName: "BundlePage__FlexMain",
  componentId: "sc-1kfcom5-5"
})(["", ";"], _responsiveBreakpoints.default.tabletPortrait(_templateObject6()));

var BundleHubPicker = _styledComponents.default.div.withConfig({
  displayName: "BundlePage__BundleHubPicker",
  componentId: "sc-1kfcom5-6"
})(["margin-right:40px;max-width:100%;min-width:50%;", ";", ";"], _responsiveBreakpoints.default.cs(_templateObject7()), _responsiveBreakpoints.default.tabletPortrait(_templateObject8()));

var BundlePage = function BundlePage(_ref) {
  var activeCurrencyCode = _ref.activeCurrencyCode,
      country = _ref.country,
      hasPricingAndPurchasingSucceeded = _ref.hasPricingAndPurchasingSucceeded,
      hasPricingAndPurchasingFailed = _ref.hasPricingAndPurchasingFailed;
  var isInMCBeta = (0, _reactRedux.useSelector)(_MarketingContactsSelectors.isInMCBetaSelector);

  var _useBundleState = (0, _stateUtils.useBundleState)(isInMCBeta),
      _useBundleState2 = (0, _slicedToArray2.default)(_useBundleState, 2),
      state = _useBundleState2[0],
      setState = _useBundleState2[1];

  var selectedAddOns = state.selectedAddOns;
  (0, _queryParamUtils.useQueryParamsEffect)(state);
  var restrictedAddons = (0, _reactRedux.useSelector)(function (reduxState) {
    return Object.keys(_AddonBundleRestrictionsMap.default).reduce(function (acc, addOnId) {
      if (_AddonBundleRestrictionsMap.default[addOnId].isRestricted(state, reduxState)) {
        return [].concat((0, _toConsumableArray2.default)(acc), [parseInt(addOnId, 10)]);
      }

      return acc;
    }, []);
  }, _reactRedux.shallowEqual); // remove any addons that do not fit bundle requirements

  (0, _react.useEffect)(function () {
    if (!hasPricingAndPurchasingSucceeded) return; // Wait until all ownership info is in before enforcing restrictions

    restrictedAddons.forEach(function (addOnId) {
      if (restrictedAddons.includes(addOnId) && selectedAddOns.includes(addOnId)) {
        var updatedSelectedAddons = selectedAddOns.filter(function (id) {
          return id !== addOnId;
        });
        setState({
          selectedAddOns: updatedSelectedAddons
        });
      }
    });
  });
  (0, _react.useEffect)(function () {
    (0, _getUsageTracker.default)().setProperties({
      activeCurrencyCode: activeCurrencyCode,
      countryTerritory: country
    });
    (0, _getUsageTracker.default)().track('pageView', {
      screen: _Tracking.SCREENS.CREATE_BUNDLE
    });
  }, []);
  return _react.default.createElement(_TabLayout.default, {
    selectedPrimaryTab: "bundle",
    selectedSecondaryTab: "create-a-bundle"
  }, _react.default.createElement(BundleContext.Provider, {
    value: {
      state: state,
      setState: setState
    }
  }, _react.default.createElement(_PageContainer.default, null, hasPricingAndPurchasingFailed && _react.default.createElement(FailedContentContainer, null, _react.default.createElement(_FailedLoadBanner.default, {
    hasFailed: hasPricingAndPurchasingFailed
  })), hasPricingAndPurchasingSucceeded && _react.default.createElement(_reactRhumb.NavMarker, {
    name: "BUNDLE_PAGE"
  }), _react.default.createElement(_CurrencyPicker.default, null), _react.default.createElement(PageTitle, {
    "data-selenium-id": "page-success"
  }, _react.default.createElement(_FormattedMessage.default, {
    message: "bundles.pageTitle"
  })), _react.default.createElement(SubTitle, null, _react.default.createElement(_FormattedMessage.default, {
    message: "bundles.subtitle"
  })), _react.default.createElement(ContentContainer, null, _react.default.createElement(FlexMain, null, _react.default.createElement(BundleHubPicker, null, _react.default.createElement(_SpinnerLoadWrapper.default, {
    style: {
      minHeight: '40vh'
    },
    isLoading: !hasPricingAndPurchasingSucceeded
  }, _react.default.createElement(_MarketingHubBundle.default, {
    title: _react.default.createElement(_FormattedMessage.default, {
      message: "bundles.marketing.title"
    }),
    subtitle: _react.default.createElement(_FormattedMessage.default, {
      message: "bundles.marketing.subtitle"
    })
  }), _react.default.createElement(_SalesHubBundle.default, {
    title: _react.default.createElement(_FormattedMessage.default, {
      message: "bundles.sales.title"
    }),
    subtitle: _react.default.createElement(_FormattedMessage.default, {
      message: "bundles.sales.subtitle"
    })
  }), _react.default.createElement(_ServiceHubBundle.default, {
    title: _react.default.createElement(_FormattedMessage.default, {
      message: "bundles.service.title"
    }),
    subtitle: _react.default.createElement(_FormattedMessage.default, {
      message: "bundles.service.subtitle"
    })
  }), _react.default.createElement(_CmsHubBundle.default, {
    title: _react.default.createElement(_FormattedMessage.default, {
      message: "bundles.cms.title"
    }),
    subtitle: _react.default.createElement(_FormattedMessage.default, {
      message: "bundles.cms.subtitle"
    })
  }), _react.default.createElement(_AddOns.default, {
    title: _react.default.createElement(_FormattedMessage.default, {
      message: "bundles.addOns.title"
    }),
    subtitle: _react.default.createElement(_FormattedMessage.default, {
      message: "bundles.addOns.subtitle"
    })
  }), _react.default.createElement(_Services.default, {
    title: _react.default.createElement(_FormattedMessage.default, {
      message: "bundles.services.title"
    }),
    subtitle: _react.default.createElement(_FormattedMessage.default, {
      message: "bundles.services.subtitle"
    })
  }))), _react.default.createElement(StickyContainer, null, _react.default.createElement(_SpinnerLoadWrapper.default, {
    isLoading: !hasPricingAndPurchasingSucceeded
  }, _react.default.createElement(_ShoppingCart.default, null)), _react.default.createElement(_PhoneSupport.default, {
    phoneSourceId: "bundle",
    border: false,
    screen: _Tracking.SCREENS.CREATE_BUNDLE
  }))))), _react.default.createElement(_FooterMicrocopy.default, null)));
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    activeCurrencyCode: (0, _CurrencySelectors.activeCurrencySelector)(state),
    country: (0, _CountrySelectors.countrySelector)(state),
    hasPricingAndPurchasingFailed: (0, _LoadingStateSelectors.hasPricingAndPurchasingFailedSelector)(state),
    hasPricingAndPurchasingSucceeded: (0, _LoadingStateSelectors.hasPricingAndPurchasingSucceededSelector)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)((0, _DocumentUtils.withDocumentTitle)(BundlePage, 'bundle'));

exports.default = _default;